/**
 * Cuenta el tiempo ACTIVO en una ruta: corre con la pestaña a la vista y alguien usándola, y se
 * para cuando pasa a segundo plano o deja de haber teclado y puntero. Es lo que separa «estuvo
 * diez minutos en el formulario» de «dejó la pestaña abierta y se fue a comer».
 */
export class ActiveClock {
    private accumulated = 0;
    private since: number | null;

    constructor (now: number, running = true) {
        this.since = running ? now : null;
    }

    get running (): boolean {
        return this.since !== null;
    }

    pause (at: number): void {
        if (this.since === null) return;
        this.accumulated += Math.max(0, at - this.since);
        this.since = null;
    }

    resume (at: number): void {
        if (this.since === null) this.since = at;
    }

    read (at: number): number {
        return this.accumulated + (this.since === null ? 0 : Math.max(0, at - this.since));
    }
}
